import { Page } from '@app/components/page/Page';
import { StationIcon } from '@app/components/stations/StationIcon';
import { ListViewLocal } from '@app/core/list-view/ListViewLocal';
import { Station } from '@app/core/types/stations';
import { stationsStationsGetAll } from '@mi-front/api-v2';
import { useIntl } from 'react-intl';
import { AdminStationsList } from './AdminStationsList';
import { ADMIN_STATIONS_FILTERS_CONFIG } from './filters/admin-stations-filters-config';

/**
 * Admin stations list: loads stations once and filters locally via ListViewLocal.
 */
export function AdminStationsListPage() {
  const { $t } = useIntl();
  const title = $t({
    id: 'admin.stations.listScreen.title',
    defaultMessage: 'Emisoras',
  });

  const queryFn = async (): Promise<Station[]> => {
    const data = await stationsStationsGetAll();
    return data as unknown as Station[];
  };

  return (
    <Page htmlTitle={title}>
      <Page.Header icon={<StationIcon />} title={title} />
      <ListViewLocal
        listId="admin-stations"
        filters={ADMIN_STATIONS_FILTERS_CONFIG}
        queryFn={queryFn}
        ListComponent={AdminStationsList}
        ListWrapper={Page.Content}
        enablePagination={false}
        showProgress
      />
    </Page>
  );
}
